function getHorizontalBarChartData(salesSummaryList, year) {
  // param: salesSummaryList: lista the objetos tipo SalesSummary
  const default_label = "Ventas Año " + year;
  var labels = [];
  var data = [];

  salesSummaryList.forEach((elem) => {
    labels.push(elem.company);
    data.push(elem.total);
  });

  // return values in a format that charts components understand
  return {
    labels: labels,
    datasets: [
      {
        label: default_label,
        color: "dark",
        data: data,
      },
    ],
  };
}

export default getHorizontalBarChartData;
